export default "__VITE_ASSET__13c09754__"